// src/shared/components/ConfirmationModal/index.js
import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ConfirmationModal = ({
    show,
    onHide,
    onConfirm,
    title,
    message,
    confirmText = 'Confirm',
    confirmVariant = 'primary',
    isLoading = false,
    cancelText = 'Cancel'
}) => {
    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {message}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide} disabled={isLoading}>
                    {cancelText}
                </Button>
                <Button 
                    variant={confirmVariant} 
                    onClick={onConfirm}
                    disabled={isLoading}
                >
                    {isLoading ? (
                        <>
                            <i className="bi bi-arrow-repeat spinner me-2"></i>
                            {confirmText}
                        </>
                    ) : (
                        confirmText
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmationModal;
